import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';


type requestBody = {
  method: string
  data?: any,
  id?: string,
  idCompany?: string
}


@Injectable({
  providedIn: 'root'
})
export class MarketPlaceService {

    private urlMarketplace:string = `${environment.apiCore}/marketplace/`;

    constructor( private http: HttpClient ) { }

    //Servicios Papelera Noe 1.2
    listarOpcionesMarketPlace(empresa:any, categoria:any):Observable<any> {
      const body:requestBody = { method: 'LIST-OPTIONS', data: { idCompany:0, category:categoria}}
      return this.http.post(this.urlMarketplace, body, { headers: { "x-api-key": environment.xApiKey } })
    }

    listarOpcionesModalCompra(empresa:any):Observable<any> {
      const body:requestBody = { method: 'LIST-OPTIONS-MODAL', data: { idCompany:empresa}}
      return this.http.post(this.urlMarketplace, body, { headers: { "x-api-key": environment.xApiKey } })
    }

    listarPlanes(data):Observable<any> {
      const body:requestBody = { method: 'LIST-PLANS', data: data}
      return this.http.post(this.urlMarketplace, body, { headers: { "x-api-key": environment.xApiKey } })
    }

    listarPlanesPorUsuario(data):Observable<any> {
      const body:requestBody = { method: 'LIST-PLANS-FOR-USER', data: data}
      return this.http.post(this.urlMarketplace, body, { headers: { "x-api-key": environment.xApiKey } })
    }

    actualizarAtributosMarketPlace(data):Observable<any> {
      const body:requestBody = { method: 'UPDATE-PLAN-USER', data: data}
      return this.http.post(this.urlMarketplace, body, { headers: { "x-api-key": environment.xApiKey } })
    }

    listarUsuarioPlan(user:string, subdomain:any):Observable<any>{
      const body:requestBody = { method: 'LIST-USER-PLAN', data: { email:user, subdomain:subdomain }}
      return this.http.post(this.urlMarketplace, body, { headers: { "x-api-key": environment.xApiKey } })
    }
}